module.exports = __webpack_public_path__ + "img/C04TechSparabaraS_ua.0c6f0df2.webp";